<template>
  <div>
    <nav class="navbar navbar-gorehco navbar-static-top mb-0" role="navigation">
      <div class="container">
        <div class="navbar-header">
          <a href="" class="navbar-brand">{{ titulo }}</a>
        </div>
      </div>
    </nav>
    <section class="jumbotron">
      <div v-if="status" class="container">
        <button class="btn btn-sm btn-danger" @click="nuevaBusqueda()">Nueva busqueda</button>
      </div>
    </section>
    <div v-if="!status" class="container">
      <div class="col-md-8 col-md-offset-2">
        <div class="panel-group">
          <div class="panel panel-success">
            <form class="form-horizontal" @submit.prevent="recaptcha()">
              <div class="panel panel-success">
                <div class="panel-heading">VERIFICACIÓN DE DOCUMENTOS FIRMADOS DIGITALMENTE</div>
                <div class="panel-body text-center">
                  <div class="form-group">
                    <label class="col-md-4 control-label">Reg. Doc.</label>
                    <div class="col-md-6">
                      <input v-model="formData.iddocumento" type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-4 control-label">Contraseña</label>
                    <div class="col-md-6">
                      <input v-model="formData.docu_contrasenia" type="text" class="form-control" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel panel-success">
                <div class="panel-body text-right">
                  <button class="btn btn-success">Buscar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="status" class="container-fluid">
      <div class="row">
        <!-- Contenedor del documento principal -->
        <div v-if="principal" :class="anexos.length > 0 ? 'col-md-9' : 'col-md-12'">
          <iframe
            :src="routePrintPdf.replace(/%s/, principal.id).replace(/%s/s, formData.iddocumento) + '&tipo=' + tipo + '&raw=1'"
            frameborder="0"
            style="width:100%; height:845px; border: 1px solid #ccc; border-radius: 4px;"
          ></iframe>
        </div>
        
        <!-- Contenedor de anexos / adjuntos -->
        <div class="col-md-3" v-if="anexos.length > 0">
          <div class="panel panel-success">
            <div class="panel-heading">
              <h3 class="panel-title"><span class="glyphicon glyphicon-paperclip"></span> Documentos Anexos</h3>
            </div>
            <div class="panel-body">
              <div class="list-group" style="max-height: 800px; overflow-y: auto;">
                <a 
                  v-for="(anexo, index) in anexos" 
                  :key="index"
                  :href="routePrintPdf.replace(/%s/, anexo.id).replace(/%s/s, formData.iddocumento) + '&tipo=' + tipo + '&raw=1'" 
                  target="_blank"
                  class="list-group-item"
                  style="word-wrap: break-word;"
                >
                  <span class="glyphicon glyphicon-file text-success"></span> {{ anexo.file_name || ('Anexo ' + (index + 1)) }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/js/plugins/client'
export default {

  props : {
    routePrintPdf : {
      type    : String,
      default : ''
    },
    routeBuscarDigital : {
      type    : String,
      default : ''
    },
    titulo : {
      type    : String,
      default : ''
    }
  },

  data() {
    return {
      formData : {
        iddocumento      : null,
        docu_contrasenia : null,
        id               : null,
        token            : null
      },
      status    : false,
      tipo      : null,
      digitales : {
        id : null
      }
    }
  },

  computed: {
    principal() {
      if (!Array.isArray(this.digitales)) return null;
      return this.digitales.find(d => d.file_principal) || this.digitales[0]
    },
    anexos() {
      if (!Array.isArray(this.digitales)) return [];
      const principalId = this.principal ? this.principal.id : null;
      return this.digitales.filter(d => !d.file_principal && d.id !== principalId)
    }
  },

  methods : {
    buscarDocumento() {
      axios.get(this.routeBuscarDigital, { params: this.formData }).then(response => {
        if (response.data.status) {
          this.status = response.data.status
          // this.formData.id = response.data.data.id
          this.digitales = response.data.data
          this.tipo = response.data.tipo
          console.log(response.data.data)
        } else {
          alert('No se encontro el digital del documento')
        }
      })
    },

    recaptcha() {
      if (this.formData.iddocumento > 0) {
        this.$recaptcha('login').then(token => {
          this.formData.token = token
          this.buscarDocumento()
          //console.log(token) // Will print the token
        })
      } else {
        alert('Digite bien el registro')
      }
    },

    nuevaBusqueda() {
      this.status = false
      this.formData = {}
    }
  }
}
</script>
